import React, { Component, Fragment } from 'react';
import {
  shape, node,
} from 'prop-types';
import { withRouter } from 'react-router';

class ScrollToTop extends Component {
  static propTypes = {
    children: node.isRequired,
    location: shape(),
  };

  static defaultProps = {
    location: null,
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { children } = this.props;

    return (
      <Fragment>
        {children}
      </Fragment>
    );
  }
}

export default withRouter(ScrollToTop);
